import { createCustomizedEntityAdapterForForms } from "../util/entityAdapters/adapters";

export const jsonEntityAdapters = {};

export const createAdapter = (s3Path) => {
  if (!jsonEntityAdapters[s3Path]) {
    jsonEntityAdapters[s3Path] = {
      adapter: createCustomizedEntityAdapterForForms(),
    };
  }
  return jsonEntityAdapters?.[s3Path]?.adapter;
};


export const getAdapter = (s3Path) => {
  return jsonEntityAdapters?.[s3Path]?.adapter;
};
